import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { useMemo } from 'react';
import { getIsWebGlSupportedViaPixiUtil, isWebGlWarningForced } from '../../utils/webGlUtils';
export const WebGlUnsupportedWarningContainer = () => {
    const isWebGlSupported = useMemo(() => (isWebGlWarningForced() ? false : getIsWebGlSupportedViaPixiUtil()), []);
    if (isWebGlSupported) {
        return null;
    }
    return (_jsxs("div", { css: css `
        background-color: black;
        color: yellow;
        padding: 10px;
        margin: 10px;
        border-radius: 10px;
      `, children: [_jsxs("div", { css: css `
          display: flex;
          flex-flow: row wrap;
          align-items: center;
        `, children: [_jsx(WarningRoundedIcon, {}), " WebGL support is required but was not detected."] }), _jsxs("ul", { children: [_jsx("li", { children: "Try upgrading your graphics card (GPU) drivers to the latest version." }), _jsx("li", { children: "Try enabling \"WebGL\" or \"hardware acceleration\" on your browser or device." }), _jsx("li", { children: "Try Google Chrome." })] })] }));
};
